// extracted by mini-css-extract-plugin
export default {"image":"rFjnTF","wrapper":"Obo2RB","label":"WFbWAj"};